var exports = {
  "t8": "MobileFriendRequestItem.module__requestItem___SllORE",
  "eF": "MobileFriendRequestItem.module__userInfo___SllORE",
  "nT": "MobileFriendRequestItem.module__userName___SllORE",
  "G2": "MobileFriendRequestItem.module__requestStatus___SllORE",
  "hP": "MobileFriendRequestItem.module__actionButton___SllORE" + " " + __webpack_require__(790033)["AS"] + " " + __webpack_require__(790033)["ik"],
  "RK": "MobileFriendRequestItem.module__iconSize___SllORE",
};

module.exports = exports;
